
import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingBottom: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,

  },
  showBorder: {
    borderBottomWidth: 3,
    borderBottomColor: PALETTE.sortingHeaderBorder,
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  itemFirst: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  itemLast: {
    justifyContent: 'flex-end',
    marginRight: 50,
  },
  label: {
    // letterSpacing: -0.5,
    //color: PALETTE.secondaryText,
    textAlign: 'right',
  },
  quantityLabel: {
    // letterSpacing: -0.5,
    //color: PALETTE.secondaryText,
    textAlign: 'right',
    paddingRight: 50
  },
  quantityLabelAsset:{
    // letterSpacing: -0.5,
    //color: PALETTE.secondaryText,
    textAlign: 'right',
    paddingRight: 2
  },
  sortArrow: {
    marginTop: 5,
    marginLeft: 5,
    width: 20,
    height: 20,
  },
  customItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  customItemCenterStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});
